export default {
  type: 'Commercial',
  sections: [
    { id: 'home1', title: 'Commercial Insurance Introduction' },
    { id: 'whatis', title: 'What is Commercial Insurance' },
    { id: 'home3', title: 'Main Price Impacting Factors' },
    { id: 'home4', title: 'Bundle and Save' }
  ],
  introData: {
    title: 'Understanding Commercial Insurance',
    paragraphs: [
      "Welcome to Insurance Express's commercial insurance guide! As a leading provider of commercial insurance in our region, we're dedicated to helping business owners protect their assets and their employees. With years of experience in the industry, we have the knowledge and expertise to help you understand the ins and outs of commercial insurance.",
      "In this guide, we'll explain what commercial insurance is, the different types of policies available, and provide tips on how to get the best rate on your policy. Whether you're a small business owner or managing a large corporation, we hope that this guide will provide you with the information you need to make an informed decision."
    ]
  },
  understandingSection: {
    title: 'Understanding Commercial Insurance: Policies, Coverage, and Limits.'
  },
  coverageItems: [
    "What is commercial insurance and why is it important",
    "Types of commercial insurance policies: general liability, property, and workers' compensation",
    "Components of a commercial insurance policy: coverage limits, deductibles, and endorsements",
    "What does commercial insurance typically cover?",
    "What is not covered by commercial insurance?",
    "How much commercial insurance coverage do you need?"
  ],
  detailsSection: {
    title: "What is commercial insurance and why is it important?",
    description: "Commercial insurance is a type of insurance that provides financial protection for businesses and their assets. It can help cover the costs associated with property damage, liability claims, and injuries to employees or customers. Without commercial insurance, a business could be left with a significant financial burden in the event of an unexpected event.",
    subtitle: "In this article, we'll cover the key topics related to commercial insurance, including:",
    items: [
      "Types of commercial insurance policies and what they cover.",
      "Components of a commercial insurance policy, such as coverage limits, deductibles, and endorsements.",
      "What commercial insurance typically covers and what it does not cover.",
      "Factors to consider when determining how much coverage you need.",
      "Common mistakes to avoid when selecting a commercial insurance policy.",
      "Tips for saving money on commercial insurance premiums."
    ]
  },
  additionalInfo: {
    sections: [
      {
        title: "Types of commercial insurance policies:",
        paragraphs: [
          "General liability insurance: Covers claims of bodily injury, property damage, and advertising injury. Property insurance: Covers damage to your business property, including buildings, equipment, and inventory. Workers' compensation insurance: Provides financial assistance to employees who are injured or become ill while on the job."
        ]
      },
      {
        title: "Components of a commercial insurance policy:",
        paragraphs: [
          "Coverage limits: The maximum amount that your insurance policy will pay out for a covered claim. Deductibles: The amount that you'll need to pay out of pocket before your insurance coverage kicks in. Endorsements: Additional coverage options that can be added to your policy to provide extra protection for specific risks."
        ]
      },
      {
        title: "What does commercial insurance typically cover?",
        paragraphs: [
          "Property damage caused by natural disasters, theft, and other incidents. Liability claims from third parties, including bodily injury and property damage. Injuries to employees while on the job."
        ]
      },
      {
        title: "What is not covered by commercial insurance?",
        paragraphs: [
          "Damage caused by floods or earthquakes (requires separate insurance policies). Intentional acts or criminal activity. Normal wear and tear or lack of maintenance."
        ]
      },
      {
        title: "How much commercial insurance coverage do you need?",
        paragraphs: [
          "The amount of coverage you need depends on factors such as the size of your business, the value of your assets, and the level of risk in your industry."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Commercial Insurance",
    description: "When comparing rates and coverages for commercial insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Type of Business",
        description: "The industry in which your business operates in can have a significant impact on the cost of your insurance. Industries with higher risks, such as construction or healthcare, may have higher insurance premiums.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Location",
        description: "Where your business is located can also affect the cost of your insurance. Factors such as crime rates and natural disaster risks can impact your rate.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Size of the Business",
        description: "The size of your business can affect the cost of your insurance, as well as the amount of coverage you need.",
        imageUrl: "/images/productPageImages/credit.png"
      },
      {
        title: "Claims History",
        description: "A history of claims can increase your insurance premiums. It's important to take steps to prevent accidents and minimize risks in your business to keep your insurance costs as low as possible.",
        imageUrl: "/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Auto Insurance",
      imageUrl: "/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    }
  ],
  ctaText: "(Home, Auto, Life, etc.)"
}; 